import React, { useCallback } from 'react';
import { TMenuContentVersion } from 'types';
import { Checkbox, Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';

interface IUseRestaurantMenuVersionCheckBox {
	toggleUseMenuVersion: (value: TMenuContentVersion) => void;
	useMenuVersion: TMenuContentVersion;
}

const UseRestaurantMenuVersionCheckBox: React.FC<IUseRestaurantMenuVersionCheckBox> = ({
	toggleUseMenuVersion,
	useMenuVersion,
}) => {
	const handleChange = useCallback(
		(e: CheckboxChangeEvent) => {
			if (e.target.checked) {
				toggleUseMenuVersion('Restaurant');
			} else {
				toggleUseMenuVersion('None');
			}
		},
		[toggleUseMenuVersion],
	);

	return (
		<Form.Item name="useMenuVersion">
			<Checkbox
				checked={useMenuVersion === 'Restaurant'}
				onChange={handleChange}
				disabled={useMenuVersion === 'Customer'}>
				<Text translationNameSpace="form" translationKey="useRestaurantMenuVersionLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseRestaurantMenuVersionCheckBox);
